import { Component, ViewChild } from '@angular/core';
import { BusyIndicatorCircularComponent } from 'source/app/controls/components/busy-indicator/busy-indicator-circular/busy-indicator-circular-component';

@Component({
  templateUrl: './busy-indicators.html'  
})
export class BusyIndicatorsComponent { 

    constructor() {
      this.ItemsSource = 
      [
        { Name:'Welcome', View: 'welcome', Path: '/home/welcome'},
        { Name:'ListBox', View: 'list-box', Path: '/home/list-box'}
      ];
    }

    public ItemsSource;
    public SelectedItem;

    @ViewChild(BusyIndicatorCircularComponent) BusyIndicatorsControl: BusyIndicatorCircularComponent;
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/busy-indicators/busy-indicators-component.ts